"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7930],{

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./components/indicator/index.ts + 2 modules
var indicator = __webpack_require__(81049);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.css
var carousel = __webpack_require__(75472);
;// CONCATENATED MODULE: ./components/core/Carousel/Carousel.tsx






const imagesReducer = (images)=>{
    const imagesArr = [];
    if (images && images.length) {
        images.forEach((el)=>{
            const object = el;
            const key = Object.keys(el)[1];
            imagesArr.push(object[key]);
        });
        return imagesArr;
    }
    return;
};
const DEFAULT_CENTER_SLIDE_PERCENTAGE = 80;
const Carousel = (param)=>{
    let { images , imgClassName , children , centerMode , onSwipe , onChange , centerSlidePercentage , infinite =true  } = param;
    const imagesArr = imagesReducer(images);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(js/* Carousel */.lr, {
        onChange: onChange,
        onSwipeMove: onSwipe,
        showIndicators: true,
        showArrows: false,
        showStatus: false,
        swipeable: true,
        emulateTouch: true,
        preventMovementUntilSwipeScrollTolerance: true,
        swipeScrollTolerance: 50,
        infiniteLoop: infinite,
        showThumbs: false,
        autoPlay: false,
        centerMode: centerMode,
        centerSlidePercentage: centerSlidePercentage || DEFAULT_CENTER_SLIDE_PERCENTAGE,
        renderIndicator: (onClickHandler, isSelected, index, label)=>{
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(indicator/* default */.Z, {
                onClickHandler: onClickHandler,
                isSelected: isSelected,
                index: index,
                label: label
            });
        },
        children: (imagesArr === null || imagesArr === void 0 ? void 0 : imagesArr.map((item, index)=>{
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                ...(0,imageSerializer/* imageSerializer */.l)(item),
                className: imgClassName
            }, index);
        })) || children
    });
};

;// CONCATENATED MODULE: ./components/core/Carousel/index.ts

/* harmony default export */ var core_Carousel = (Carousel);


/***/ }),

/***/ 81049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ indicator; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/indicator/indicator.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Item = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "eanor9r0"
})("position:relative;width:0.75rem;height:0.75rem;border:0.0625rem solid ", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";border-radius:50%;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";overflow:hidden;margin:0 1.375rem 0 0;");
const RadioButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eanor9r1"
})("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);overflow:hidden;width:0.5rem;height:0.5rem;border-radius:50%;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";", (param)=>{
    let { isSelected  } = param;
    return isSelected && (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), theme/* THEME.colors.primary */.C.colors.primary);
}, ";");

;// CONCATENATED MODULE: ./components/indicator/Indicator.tsx


const Indicator = (param)=>{
    let { onClickHandler , isSelected , index , label  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RadioButton, {
            isSelected: isSelected
        })
    });
};


;// CONCATENATED MODULE: ./components/indicator/index.ts

/* harmony default export */ var indicator = (Indicator);


/***/ }),

/***/ 94671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WhatWeHaveBuilt": function() { return /* binding */ WhatWeHaveBuilt; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/sections/ProductDesign/WhatWeHaveBuilt/icons/dribble.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDribble = function SvgDribble(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.688 32C.688 14.327 14.931 0 32.5 0c17.57 0 31.812 14.327 31.812 32 0 17.673-14.243 32-31.812 32C14.931 64 .688 49.673.688 32Zm48.779-.024a17.155 17.155 0 0 0-1.336-6.634 17.168 17.168 0 0 0-3.635-5.418 17.363 17.363 0 0 0-2.51-2.078 16.785 16.785 0 0 0-6.07-2.566 17.032 17.032 0 0 0-6.833 0 16.73 16.73 0 0 0-6.071 2.566 17.258 17.258 0 0 0-2.509 2.078 17.05 17.05 0 0 0-4.626 8.621 17.323 17.323 0 0 0 0 6.862 17.06 17.06 0 0 0 2.555 6.097c.606.903 1.304 1.75 2.071 2.522a17.345 17.345 0 0 0 2.509 2.08 17.123 17.123 0 0 0 2.883 1.572 16.926 16.926 0 0 0 6.604 1.341 16.975 16.975 0 0 0 6.605-1.341 17.11 17.11 0 0 0 2.882-1.571 17.451 17.451 0 0 0 2.51-2.08 17.17 17.17 0 0 0 3.635-5.417c.434-1.03.766-2.107.99-3.203.229-1.124.346-2.276.346-3.43Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.617 28.49c5.72-2.347 8.044-5.72 8.072-5.76a14.519 14.519 0 0 1 3.295 9.096c-.21-.043-5.114-1.101-10.091-.472a46.164 46.164 0 0 0-1.276-2.864Zm4.98 15.556c-.148-.877-.92-5.15-2.821-10.395 4.677-.754 8.73.535 9.029.632a14.565 14.565 0 0 1-6.209 9.763Zm-5.536-9.721c2.039 5.322 2.88 9.78 3.095 11.051a14.417 14.417 0 0 1-14.562-1.927c.03-.066 2.822-6.1 11.371-9.093l.096-.031Zm7.007-13.272c-.035.053-2.099 3.21-7.566 5.268-2.478-4.57-5.2-8.197-5.417-8.49a14.508 14.508 0 0 1 3.414-.408c3.669 0 7.018 1.37 9.57 3.63Zm-9.17 8.387a49.25 49.25 0 0 1 1.175 2.473c-.19.055-.382.112-.571.175-7.82 2.54-11.784 9.606-11.78 9.613a14.528 14.528 0 0 1-3.712-9.725c0-.156.008-.308.012-.464.257.01 7.416.171 14.876-2.072Zm-6.58-10.628c.192.259 2.872 3.911 5.38 8.387-6.957 1.856-12.995 1.78-13.377 1.776a14.561 14.561 0 0 1 7.996-10.163Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var dribble = (SvgDribble);
;// CONCATENATED MODULE: ./components/sections/ProductDesign/WhatWeHaveBuilt/icons/behance.svg
var behance_path;
function behance_extends() { behance_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return behance_extends.apply(this, arguments); }

var SvgBehance = function SvgBehance(props) {
  return /*#__PURE__*/react.createElement("svg", behance_extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), behance_path || (behance_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.312 0c-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32Zm13.784 24.893h-9.04v-2.59h9.04v2.59Zm-4.466 1.451c1.359 0 2.581.242 3.669.723 1.09.48 1.987 1.24 2.693 2.277.644.915 1.058 1.976 1.246 3.182.11.704.155 1.726.137 3.055H38.01c.068 1.542.606 2.625 1.633 3.245.622.386 1.371.58 2.25.58.925 0 1.682-.236 2.262-.705.319-.255.6-.608.84-1.06h4.165c-.11.912-.616 1.84-1.511 2.782-1.397 1.495-3.354 2.244-5.868 2.244-2.078 0-3.91-.63-5.493-1.893-1.592-1.261-2.382-3.316-2.382-6.16 0-2.666.716-4.712 2.147-6.135 1.435-1.42 3.291-2.135 5.577-2.135Zm-16.192-5.01c2.573.037 4.393.776 5.467 2.217.644.885.967 1.942.967 3.176 0 1.269-.323 2.292-.975 3.064-.365.432-.9.828-1.61 1.184 1.076.388 1.887 1 2.439 1.838.546.835.82 1.853.82 3.049 0 1.233-.312 2.34-.94 3.318a5.781 5.781 0 0 1-1.494 1.638c-.672.508-1.464.855-2.382 1.045-.917.188-1.908.279-2.98.279h-9.505V21.333h10.193Zm-1.396 3.613H19.45v4.591h5.13c.913 0 1.657-.172 2.231-.517.57-.344.857-.954.857-1.825 0-.972-.377-1.612-1.132-1.925-.654-.215-1.485-.324-2.494-.324Zm17.59 4.718c-1.043 0-1.858.293-2.434.879-.576.586-.94 1.38-1.088 2.382h7.03c-.074-1.07-.44-1.877-1.085-2.434-.655-.552-1.46-.827-2.423-.827ZM24.644 32.98H19.45v5.55h5.122c.915 0 1.63-.123 2.137-.367.925-.455 1.387-1.318 1.387-2.597 0-1.085-.446-1.828-1.343-2.233-.502-.226-1.206-.345-2.11-.353Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var icons_behance = (SvgBehance);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./components/sections/ProductDesign/WhatWeHaveBuilt/SocialItem/socialItem.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 32px 40px;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const ItemText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e13umf0o0"
})("font-family:var(--font-base);font-size:20px;font-weight:400;line-height:32px;letter-spacing:0;text-align:left;color:#ffffff;");
const SocialItemLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e13umf0o1"
})("display:flex;flex-direction:row;align-items:center;border-radius:0.5rem;gap:1.5rem;padding:16px 20px;background:#0e4ed7;text-decoration:none;white-space:nowrap;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), "  &:hover{background:linear-gradient(22.45deg,#0e4ed7 3.28%,#f94743 102.02%);/* drop shadow */\n\n    box-shadow:8px 8px 24px rgba(23,0,89,0.29);}");
const IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e13umf0o2"
})("width:64px;height:64px;");

;// CONCATENATED MODULE: ./components/sections/ProductDesign/WhatWeHaveBuilt/SocialItem/SocialItem.tsx



const SocialItem = (param)=>/*#__PURE__*/ {
    let { icon , link , text  } = param;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SocialItemLink, {
        href: link,
        "aria-label": "Behance",
        rel: "noopener noreferrer",
        target: "_blank",
        className: "what-we-have-built__socials-card what-we-have-built__behance",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: icon
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemText, {
                children: [
                    "on ",
                    text
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/ProductDesign/WhatWeHaveBuilt/whatWeHaveBuilt.styles.tsx

function whatWeHaveBuilt_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.5rem;\n    line-height: 3.5rem;\n    margin-bottom: 2.5rem;\n    letter-spacing: -0.0125rem;\n  "
    ]);
    whatWeHaveBuilt_styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    margin-bottom: 4rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 42.5rem;\n    min-height: 134rem;\n    max-width: 40.5rem;\n    max-height: 185.875rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 57.5rem;\n    min-height: 116rem;\n    max-width: 40.5rem;\n    max-height: 222.625rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 73.125rem;\n    min-height: 140rem;\n    max-width: 73.125rem;\n    max-height: 295.75rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.5rem;\n    line-height: 3.5rem;\n    margin-top: 2.5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15qi8n80"
})(mixins/* defaultContainerSize */.sX, ";padding-top:4rem;padding-bottom:5rem;position:relative;z-index:0;}");
const SocialTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e15qi8n81"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:3rem;font-weight:400;line-height:3.5rem;letter-spacing:-0.0125rem;text-align:center;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0 0 2rem 0;width:100%;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(whatWeHaveBuilt_styles_templateObject())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())));
const SectionImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15qi8n82"
})("width:100%;position:relative;min-width:20.5rem;min-height:83rem;max-width:32.5rem;max-height:191rem;margin:0 auto;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), "  div{position:relative !important;img{position:relative !important;height:100% !important;}}img{object-fit:contain;}");
const SectionImageMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15qi8n83"
})("width:100%;position:relative;min-width:18rem;min-height:30rem;aspect-ratio:563/721;max-width:32.5rem;margin:0 auto;");
const SocialMediaWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15qi8n84"
})("padding:2rem 3rem 3rem 3rem;background:#f4f4f4;display:flex;flex-direction:column;align-items:center;border-radius:0.5rem;");
const SocialText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e15qi8n85"
})("font-size:1.5rem;line-height:2rem;font-weight:400;text-align:center;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:4rem 0 1.5rem 0;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())));
const SocialsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15qi8n86"
})("display:flex;flex-direction:column;align-items:center;background-color:#f4f4f4;gap:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())));

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./components/core/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(80087);
;// CONCATENATED MODULE: ./components/sections/ProductDesign/WhatWeHaveBuilt/WhatWeHaveBuilt.tsx










const WhatWeHaveBuilt = (param)=>{
    let { id , title , want_to_see_more , behance_text , behance , dribbble_text , dribbble , images , mobileImages , titleAs  } = param;
    const width = (0,useWindowSize/* useWindowSize */.i)().width;
    let image;
    if (images && width && width >= 1200) {
        image = images.desktop;
    } else if (images && width && width >= 991) {
        image = images.tablet;
    } else {
        image = images.mobile;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        id: id,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialTitle, {
                as: titleAs,
                children: prismic_reactjs.RichText.asText(title)
            }),
            width && width >= 768 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionImage, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    ...(0,imageSerializer/* imageSerializer */.l)(image, {
                        layout: "fixed"
                    })
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionImageMobile, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default */.Z, {
                    images: mobileImages
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SocialMediaWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialText, {
                        children: prismic_reactjs.RichText.asText(want_to_see_more)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SocialsWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialItem, {
                                text: "Dribbble",
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dribble, {}),
                                link: "https://dribbble.com/qodeca"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialItem, {
                                text: "Behance",
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_behance, {}),
                                link: "https://www.behance.net/_qodeca"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);